import { useState } from "react";
import Roles from "./roles";
import Tabs from "./tabs";
import AccountSettings from "./accountSettings";
import { useLocation, useSearchParams } from "react-router-dom";

const Settings = () => {
  const [tab, setTab] = useState("Account Settings");

  const { search } = useLocation();
  const [searchParams] = useSearchParams(search);
  const currentTab = searchParams.get("q") || "account-settings";

  console.log(currentTab);

  return (
    <div className="h-full px-4 md:px-8 w-full">
      <h1 className=" text-[24px] leading-9 font-[600]"> Settings</h1>
      {/* tabs */}
      <div className="mt-[32px] md:flex gap-8 ">
        <div className="flex-[.9]">
          <Tabs tab={currentTab} setTab={setTab} />
        </div>

        {/* content */}
        {currentTab === "account-settings" ? (
          <div className=" flex-[1.5]">
            <AccountSettings />
          </div>
        ) : (
          <div className=" flex-[1.5]">
            <Roles />
          </div>
        )}
      </div>
    </div>
  );
};

export default Settings;
